import { environment } from '@envs/environment'

/**
 * Origens das APIs da SilGov, tiradas das chaves `url_*_api` do environment (management, pca, attachment, authentication,
 * account, customer, notification e as demais). É a lista branca do `Authorization` e dos cabeçalhos de tenant e
 * produto (spec 048): o token não vai a S3, viacep nem qualquer outro host.
 */
const apiOrigins = (source: Record<string, unknown> = environment): Set<string> =>
	new Set(
		Object.entries(source)
			.filter(([key, value]) => /^url_.+_api$/.test(key) && typeof value === 'string' && !!value)
			.map(([, value]) => originOf(value as string))
			.filter((origin): origin is string => !!origin)
	)

const originOf = (url: string): string | null => {
	try {
		return new URL(url, window.location.origin).origin
	} catch {
		return null
	}
}

let cachedOrigins: Set<string> | null = null

/** Verdadeiro só para as origens das APIs da SilGov; URL relativa ou de outro host é falso. */
export function isApiUrl(url: string, source?: Record<string, unknown>): boolean {
	if (!url || !/^https?:\/\//i.test(url)) return false

	const origins = source ? apiOrigins(source) : (cachedOrigins ??= apiOrigins())
	const origin = originOf(url)

	return !!origin && origins.has(origin)
}

/** Qualquer host de S3 (`*.s3.<região>.amazonaws.com`, `s3.amazonaws.com`, `s3-<região>.amazonaws.com`). */
export function isS3PresignedUrl(url: string): boolean {
	try {
		const host = new URL(url).hostname.toLowerCase()

		return host.endsWith('.amazonaws.com') && /(^|\.)s3([.-][a-z0-9-]+)?\.amazonaws\.com$|(^|\.)s3\./.test(host)
	} catch {
		return false
	}
}
